// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3WORT","log":"ModalInventoryLogs_log__3r0hy","date":"ModalInventoryLogs_date__39vhx","userName":"ModalInventoryLogs_userName__30G-m"};